import $ from "jquery";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useStickyHeader = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    try {
      const stickyHeader = () => {
        const $window = $(window);
        let lastScrollTop = 0;
        const $header = $(".td_sticky_header");

        const headerHeight = ($header.outerHeight() || 0) + 20;
        // const BG_CHANGE_SCROLL = 150;

        $window.on("scroll", () => {
          const windowTop = $window.scrollTop() || 0;
          const isMenuOpen = $(".td_nav_list_wrap").hasClass("td_active");
          if (isMenuOpen) return;

          if (windowTop >= headerHeight) {
            $header.addClass("td_gescout_sticky");
          } else {
            $header.removeClass("td_gescout_sticky");
            $header.removeClass("td_gescout_show");
          }

          if ($header.hasClass("td_gescout_sticky")) {
            if (windowTop < lastScrollTop) {
              $header.addClass("td_gescout_show");
            } else {
              $header.removeClass("td_gescout_show");
            }
          }

          // if (windowTop >= BG_CHANGE_SCROLL) {
          //   $header.addClass("td_bg_solid");
          // } else {
          //   $header.removeClass("td_bg_solid");
          // }
          lastScrollTop = windowTop;
        });
      };

      stickyHeader();
    } catch (error) {
      console.log(error);
    }
  }, [pathname]);
};
